export async function selectSource(source: any) {
    const constraints = {
        audio: false,
        video: {
            mandatory: {
                chromeMediaSource: 'desktop',
                chromeMediaSourceId: source.id
            }
        }
    };

    //Create a Stream
    const stream = await navigator.mediaDevices.getUserMedia(constraints as any);
    return stream;
}

export function closeStream(stream:any) {
    const tracks = stream.getTracks() || [];
    for (const track of tracks) {
        track.stop();
    }
}